/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_History_ExpiredInputs */

const en_settings_history_expired = /** @type {(inputs: Settings_History_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expired`)
};

const id_settings_history_expired = /** @type {(inputs: Settings_History_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berakhir`)
};

/**
* | output |
* | --- |
* | "Expired" |
*
* @param {Settings_History_ExpiredInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_history_expired = /** @type {((inputs?: Settings_History_ExpiredInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_History_ExpiredInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_history_expired(inputs)
	return en_settings_history_expired(inputs)
});